import axios from "axios";
import { authService } from "./authService.js";
import { API_BASE_URL } from "../config/api.js";

const apiClient = axios.create({
  baseURL: API_BASE_URL || "http://localhost:3000",
});

export const makeApiRequest = async ({
  endpoint,
  method,
  data,
  contentType = "json",
  customHeaders,
  accessToken
}) => {
  try {
    const isFormDataPayload =
      typeof FormData !== "undefined" && data instanceof FormData;
    const headers = { ...customHeaders };

    if (contentType === "form") {
      // Let the browser set multipart boundary headers when payload is FormData.
      if (!isFormDataPayload && !headers["Content-Type"]) {
        headers["Content-Type"] = "application/x-www-form-urlencoded";
      }
    } else if (!headers["Content-Type"]) {
      headers["Content-Type"] = "application/json";
    }

    if (accessToken) {
      headers["Authorization"] = `Bearer ${accessToken}`;
    }

    const config = {
      url: endpoint,
      method,
      headers,
    };

    if (data) {
      config.data = data;
    }

    const expiresAtUtc = localStorage.getItem("expiresAtUtc");
    if (new Date() >= new Date(expiresAtUtc) && accessToken) {
      const refreshToken = localStorage.getItem("refreshToken");
      const tokenData = await authService.refreshToken(refreshToken);
      localStorage.setItem("accessToken", tokenData.accessToken);
      localStorage.setItem("refreshToken", tokenData.refreshToken);
      localStorage.setItem("expiresAtUtc", tokenData.expiresAtUtc);

      config.headers ??= {};
      config.headers["Authorization"] = `Bearer ${tokenData.accessToken}`;
    }

    console.log("API Request Config:", config);
    const response = await apiClient(config);
    return response;
  } catch (error) {
    console.error("API Error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};
